import { useSearch } from '@tanstack/react-router';

/**
 * Opt-in flag for MX-driven features (branded header first), toggled via
 * `?mx=true`. The single entry point for gating MX behaviour as the migration
 * away from hardcoded pdp-graphql config grows. Mirrors the `?agent=true` flag.
 */
export const useMxEnabled = (): boolean =>
  useSearch({ strict: false })?.mx === true;
